<template>
  <el-footer>
    <div class="footers">
      <div class="footersTop">
        <img
          class="logo"
          src="../../static/image/logo3.png"
          alt=""
        >
        <div class="footerMiddle">
          <p class="p1">{{footCon[0].classification_name_cn}}</p>
          <p class="address">
            <img
              src="../../static/image/address1.png"
              alt=""
            >
            <span>{{footCon[0].children[0]}}</span>
          </p>
          <p class="phone">
            <img
              src="../../static/image/phone1.png"
              alt=""
            >
            <span>{{footCon[0].children[1]}}</span>
          </p>
          <p class="letter">
            <img
              src="../../static/image/letter1.png"
              alt=""
            >
            <span>{{footCon[0].children[2]}}</span>
          </p>
        </div>
        <div class="footerRight">
          <p class="p2">
            {{footCon[1].classification_name_cn}}
          </p>
          <div class="link">
            <a
              v-for="(item,i) of footCon[1].children"
              :key="i"
              :href="item.classification_url"
              :title="item.classification_name_cn"
              target="_blank"
            >
              <span
                class="ellipsis"
                :title="item.classification_name_cn"
              >{{item.classification_name_cn}}</span>
            </a>
          </div>
        </div>
        <img
          class="weixin"
          :src="weixin"
          alt=""
        >
      </div>
      <div class="footersBottom">
        <span class="holder">
          成都市新津区成外学校版权所有 <a href="http://www.beian.miit.gov.cn" target="_blank">蜀ICP备20023405号-1</a> 
        </span>
        <!-- <img
          class="gongan"
          src="/static/image/gongan.png"
          alt=""
        > -->
        <!-- <span class="caseNumber">
         蜀ICP备20023405号-1
        </span> -->
      </div>
    </div>
  </el-footer>
</template>
<script>
import { ClassificationGetList } from "@/api/home";
export default {
  name: "app-footer",
  data() {
    return {
      footCon: [{ children: {} }, { children: {} }], //底部导航栏
      weixin:''
    };
  },
  created() {
    ClassificationGetList({
      address: 4,
      limit: 6
    }).then(res => {
      // console.log(res.data)
      this.weixin=res.data.weixin
      this.footCon = res.data.list;
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/custom/common.scss";
.el-footer {
  padding: 0;
}
.footers {
  position: relative;
  // height: 27.6%;
  padding-top: px2Rem(50px);
  background: #333338;
  color: #fff;
  font-family: STXinwei;
  text-align: center;
  .footersTop {
    width: 100%;
    margin: auto;
    font-size: 0;

    .logo {
      display: inline-block;
      position: relative;
      top: px2Rem(15px);
      width: px2Rem(187px);
      height: px2Rem(140px);
      vertical-align: top;
    }
    .footerMiddle {
      display: inline-block;
      width: px2Rem(400px);
      margin: 0 px2Rem(60px) 0 px2Rem(100px);
      text-align: left;
      vertical-align: top;
      .p1 {
        position: relative;
        margin-bottom: px2Rem(25px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #fff;
        &::before {
          display: block;
          content: "";
          position: absolute;
          bottom: px2Rem(-10px);
          width: px2Rem(30px);
          height: 3px;
          background: #fff;
          border-radius: 2px;
        }
      }
      p {
        font-size: px2Rem(18px);
        font-weight: 400;
      }
      .address {
        img {
          width: px2Rem(16px);
          height: px2Rem(16px);
          vertical-align: top;
        }
      }
      .phone {
        margin: px2Rem(16px) 0;
        img {
          width: px2Rem(16px);
          height: px2Rem(16px);
          vertical-align: top;
        }
      }
      .letter {
        img {
          width: px2Rem(16px);
          height: px2Rem(12px);
          vertical-align: top;
        }
      }
      img {
        margin-right: px2Rem(10px);
      }
      // span{
      //   display: inline-block;
      //   width: px2Rem(325px);
      // }
    }
    .footerRight {
      display: inline-block;
      vertical-align: top;
      text-align: left;
      .p2 {
        position: relative;
        margin-bottom: px2Rem(25px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #fff;
        &::before {
          display: block;
          content: "";
          position: absolute;
          bottom: px2Rem(-10px);
          width: px2Rem(30px);
          height: 3px;
          background: #fff;
          border-radius: 2px;
        }
      }
      .link {
        width: px2Rem(260px);
        span {
          display: inline-block;
          width: px2Rem(130px);
          margin-bottom: px2Rem(17px);
          color: #fff;
          font-size: px2Rem(18px);
          font-weight: 400;
          vertical-align: top;
        }
        a:hover{
          span{
            color: #e2bb81;

          }
        }
      }
    }
    .weixin {
      display: inline-block;
      width: px2Rem(160px);
      height: px2Rem(160px);
      background: #fff;
    }
  }
  .footersBottom {
    // position: absolute;
    width: 100%;
    bottom: 0;
    padding: px2Rem(10px) 0;
    text-align: center;
    font-size: px2Rem(16px);
    font-weight: 400;
    color: #fff;
    .holder {
      margin-right: px2Rem(30px);
      a{
         color: #fff;
      }
    }
    span {
      display: inline-block;
    }
    .gongan {
      display: inline-block;
      width: 15px;
      height: 15px;
      vertical-align: middle;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/layout/AppFooter.vue